// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3vOUa","title":"Header_title__r1uuD","actions_button":"Header_actions_button__3GDx0"};